const id_sales_invoice = {
    "": "tagihan penjualan",
    add: "buat tagihan penjualan",
    detail: "detail tagihan penjualan",
    edit: "ubah tagihan penjualan",
    history: "riwayat tagihan",

    label: {
        payment_type: "jenis tagihan",
        disc_before_ppn: "potongan biaya sebelum PPN",
        do_list: "daftar DO",
        so_list: "daftar SO",
    },

    error: {
        bank_destination: "Tujuan bank tidak boleh kosong.",
        create: "Gagal membuat tagihan penjualan.",
        edit: "Gagal mengubah tagihan penjualan.",
        payment_type: "Jenis tagihan tidak boleh kosong.",
    },

    success: {
        create: "Berhasil membuat tagihan penjualan.",
        edit: "Berhasil mengubah tagihan penjualan.",
    },
}

export default id_sales_invoice;